module.exports = __webpack_public_path__ + "img/so_region_logo.6ddfddb3.png";